import React from 'react';
import PageContext from '../../contexts/pageContext';

import { useContext } from 'react';
import nextImageRendererStyles from './style';

const NextImageRenderer = ({ src, sectionIndex, ...props }) => {
  const { isCustomWebsite, pageData, isMobile } = useContext(PageContext);

  // return empty div if src is empty string or empty object or null
  if (!src || (typeof src === 'object' && Object.keys(src).length === 0)) {
    return <div />;
  }

  // checkif src url is encoded or not, if not encode it
  if (src.includes(' ')) {
    src = encodeURI(src);
  }

  try {
    let { refSetter, className } = props;
    if (isCustomWebsite) {
      const classes = nextImageRendererStyles();
      const imageLoader = ({ src, quality, width }) => {
        const breakpoints = {
          mobile: 640,
          desktop: 1200
        };

        const dynamicWidth = isMobile
          ? breakpoints.mobile
          : breakpoints?.desktop;

        if (process.env.NEXT_PUBLIC_ENV_ASSET_PREFIX !== undefined) {
          return `${
            process.env.NEXT_PUBLIC_ENV_ASSET_PREFIX
          }/_next/image?url=${src}&w=${width}&q=${quality || 75}`;
        } else {
          return `/_next/image?url=${src}&w=${width}&q=${quality || 75}`;
        }
      };
      const NextImage = require('next/image').default;
      return (
        <NextImage
          priority={sectionIndex === 0 ? true : false}
          loader={imageLoader}
          src={src}
          layout={'fill'}
          ref={refSetter}
          className={`${classes?.imageContainer} ${className}`}
          {...props}
          alt="image"
        />
      );
    } else {
      return <img ref={refSetter} className={className} src={src} />;
    }
  } catch (err) {
    console.log('next image failed', err);
    return <img ref={refSetter} className={className} src={src} />;
  }
};

export default NextImageRenderer;
